export const FormatAddress = (addressString) => {
    if(!addressString) {
        return "";
    }
const add = JSON.parse(addressString)

return add.district && add.district.name ? `${add.district.name}, ${add.town.name}, ${add.country.name}` : add.full;
}

